import * as yup from 'yup';

import DatePresenter from '../presenters/DatePresenter';

import { REQUIRED } from './errorsText';

export const validationFields = {
  storeId: yup.string().required(REQUIRED),
  startDate: yup.date().required(REQUIRED),
  endDate: yup
    .date()
    .required(REQUIRED)
    .when(
      'startDate',
      (startDate, schema) => startDate && schema.min(startDate)
    ),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (storeId) => {
  return {
    storeId: storeId,
    startDate: DatePresenter.today(),
    endDate: DatePresenter.today(),
  };
};
